<div class="page-head">
  <div>
    <p class="eyebrow">จัดการข้อมูล</p>
    <h1>ลูกค้า</h1>
    <p>ข้อมูลลูกค้าและ Sale ผู้ดูแลปัจจุบัน</p>
  </div>
  @if (canCreateCustomer()) {
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
      (click)="openCustomerModal()"
    >
      <lucide-icon name="Plus" [size]="17" /> สร้างลูกค้า
    </button>
  }
</div>
<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #customersTable
    [value]="customers()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="[
      'customerCode',
      'name',
      'phone',
      'email',
      'lineId',
      'salesOwner.firstName',
      'salesOwner.lastName',
    ]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '900px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <label class="relative w-full sm:max-w-md">
          <lucide-icon
            name="Search"
            [size]="17"
            class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400"
          />
          <input
            pInputText
            #customerQuery
            class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
            style="padding-left: 2.75rem; border-radius: 0.5rem"
            placeholder="ค้นหารหัส ชื่อ เบอร์โทร หรือ Sale"
            (input)="customersTable.filterGlobal(customerQuery.value, 'contains')"
          />
        </label>
        <app-refresh-button
          class="self-end sm:self-auto"
          label="รีเฟรชข้อมูลลูกค้า"
          [loading]="isLoadingCustomers()"
          (refresh)="loadCustomers()"
        />
        <!-- <button type="button" class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:border-sky-300 hover:bg-sky-50 hover:text-sky-700">
          <lucide-icon name="Filter" [size]="16" /> ตัวกรอง
        </button> -->
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th pSortableColumn="customerCode" class="min-w-64 text-xs whitespace-nowrap">
          ลูกค้า <p-sortIcon field="customerCode" />
        </th>
        <th class="min-w-56 text-xs whitespace-nowrap">ช่องทางติดต่อ</th>
        <th class="w-48 text-xs whitespace-nowrap">Sale ผู้ดูแล</th>
        <th pSortableColumn="createdAt" class="w-40 text-xs whitespace-nowrap">
          วันที่สร้าง <p-sortIcon field="createdAt" />
        </th>
        <th pSortableColumn="status" class="w-32 text-center text-xs whitespace-nowrap">
          สถานะ <p-sortIcon field="status" />
        </th>
        <th class="w-32 text-xs whitespace-nowrap">
          <span class="flex justify-end">ดำเนินการ</span>
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-row>
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 font-semibold text-slate-800">{{ row.name }}</p>
          <div class="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-500">
            <span class="font-medium text-sky-700">{{ row.customerCode }}</span>
            <span aria-hidden="true">•</span>
            <span>{{
              row.customerType === 'CORPORATE' ? 'บริษัท / นิติบุคคล' : 'บุคคลทั่วไป'
            }}</span>
          </div>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 font-medium whitespace-nowrap text-slate-700">{{ row.phone || '—' }}</p>
          <p class="mt-1 mb-0 max-w-60 truncate text-xs text-slate-500" [title]="row.email || ''">
            {{ row.email || 'ไม่มีอีเมล' }}
          </p>
        </td>
        <td class="py-3.5 text-[13px] text-slate-700 align-top">
          {{ row.salesOwner.firstName }} {{ row.salesOwner.lastName }}
        </td>
        <td class="py-3.5 text-[13px] whitespace-nowrap text-slate-600 align-top">
          {{ row.createdAt | date: 'dd MMM yyyy' }}
        </td>
        <td class="py-3.5 text-center align-top"><app-status-badge [status]="row.status" /></td>
        <td class="py-3.5 align-top">
          <div class="flex justify-end gap-1.5">
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
              title="ดูรายละเอียด"
              aria-label="ดูรายละเอียด"
              (click)="openCustomerDetail(row)"
            >
              <lucide-icon name="Eye" [size]="15" />
            </button>
            @if (canEditCustomer()) {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
                title="แก้ไข"
                aria-label="แก้ไข"
                [disabled]="row.status === 'DELETED'"
                (click)="openEditCustomerModal(row)"
              >
                <lucide-icon name="Pencil" [size]="15" />
              </button>
            }
            @if (canDeleteCustomer()) {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-red-200 bg-white text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
                title="ลบ"
                aria-label="ลบ"
                [disabled]="row.status === 'DELETED'"
                (click)="deleteCustomer(row)"
              >
                <lucide-icon name="Trash2" [size]="15" />
              </button>
            }
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="6">
          <div class="empty">
            <b><lucide-icon name="Search" [size]="22" /></b>
            <h3>ยังไม่มีข้อมูลลูกค้า</h3>
            <p>เมื่อเพิ่มลูกค้าแล้ว ข้อมูลจะแสดงที่นี่</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

@if (isCustomerModalOpen()) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeCustomerModal()"
  >
    <section
      class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-customer-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-6 py-5">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            ข้อมูลลูกค้า
          </p>
          <h2 id="add-customer-title" class="m-0 text-xl font-bold text-slate-800">
            {{ editingCustomer() ? 'แก้ไขข้อมูลลูกค้า' : 'เพิ่มลูกค้าใหม่' }}
          </h2>
          <p class="mt-1 mb-0 text-sm text-slate-500">
            {{
              editingCustomer()
                ? 'ปรับแก้ข้อมูลแล้วกดบันทึก'
                : 'กรอกข้อมูลที่จำเป็นสำหรับสร้างลูกค้า'
            }}
          </p>
        </div>
        <button
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
          type="button"
          aria-label="ปิดหน้าต่าง"
          (click)="closeCustomerModal()"
        >
          <lucide-icon name="X" [size]="19" aria-hidden="true" />
        </button>
      </div>

      <form [formGroup]="customerForm" (ngSubmit)="saveCustomer()">
        <div
          class="grid max-h-[65vh] grid-cols-1 gap-x-6 gap-y-0 overflow-y-auto px-5 py-5 sm:px-6 md:grid-cols-2"
        >
          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ประเภทลูกค้า <span class="text-red-500">*</span></span>
            <p-select
              class="h-11 w-full font-normal"
              formControlName="customerType"
              [options]="customerTypeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="เลือกประเภทลูกค้า"
            />
            <span class="min-h-4" aria-hidden="true"></span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ชื่อลูกค้า / บริษัท <span class="text-red-500">*</span></span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="name"
              placeholder="กรอกชื่อลูกค้า"
            />
            <span class="min-h-4">
              @if (customerForm.controls.name.touched && customerForm.controls.name.invalid) {
                <small class="font-normal text-red-600">กรุณากรอกชื่อลูกค้า</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>เลขประจำตัวผู้เสียภาษี / บัตรประชาชน<span class="text-red-500">*</span></span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="taxId"
              maxlength="13"
              placeholder="กรอก 9-13 ตัวอักษรหรือตัวเลข (ถ้ามี)"
            />
            <span class="min-h-4">
              @if (customerForm.controls.taxId.touched && customerForm.controls.taxId.invalid) {
                <small class="font-normal text-red-600">กรอก 9-13 ตัวอักษรหรือตัวเลข</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>เบอร์โทรศัพท์ <span class="text-red-500">*</span></span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="phone"
              inputmode="tel"
              placeholder="เช่น 0999999999"
            />
            <span class="min-h-4">
              @if (customerForm.controls.phone.touched && customerForm.controls.phone.invalid) {
                <small class="font-normal text-red-600">กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>อีเมล</span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              type="email"
              formControlName="email"
              placeholder="customer@example.com"
            />
            <span class="min-h-4">
              @if (customerForm.controls.email.touched && customerForm.controls.email.invalid) {
                <small class="font-normal text-red-600">รูปแบบอีเมลไม่ถูกต้อง</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>LINE ID</span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="lineId"
              placeholder="LINE ID (ถ้ามี)"
            />
            <span class="min-h-4" aria-hidden="true"></span>
          </label>

          <!-- <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>Sale</span>
            <input pInputText class="h-11 w-full font-normal" formControlName="saleName" placeholder="ชื่อ Sale (ถ้ามี)" />
            <span class="min-h-4" aria-hidden="true"></span>
          </label> -->

          <label
            class="grid content-start gap-1 text-sm font-semibold text-slate-700 md:col-span-2"
          >
            <span>ที่อยู่</span>
            <textarea
              pTextarea
              class="min-h-24 w-full resize-y font-normal"
              formControlName="address"
              placeholder="กรอกที่อยู่สำหรับติดต่อหรือออกเอกสาร"
            ></textarea>
          </label>

          <div
            class="grid content-start gap-1.5 mt-2 text-sm font-semibold text-slate-700 md:col-span-2"
          >
            <span>แนบไฟล์</span>
            <div class="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-4">
              <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                <p-fileupload
                  #attachmentUpload
                  mode="basic"
                  name="attachment"
                  chooseLabel="เลือกไฟล์"
                  accept=".pdf,.jpg,.jpeg,.png"
                  [maxFileSize]="5000000"
                  [auto]="false"
                  (onSelect)="onFileSelect($event)"
                  (onClear)="onFileClear()"
                />
                <button
                  type="button"
                  class="tw-button inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-red-200 bg-white px-4 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
                  [disabled]="!attachmentUpload.files.length"
                  (click)="attachmentUpload.clear(); onFileClear()"
                >
                  <lucide-icon name="X" [size]="16" aria-hidden="true" />
                  ยกเลิกไฟล์
                </button>
              </div>
              <p class="mt-2 mb-0 text-xs font-normal text-slate-500">
                รองรับไฟล์ PDF, JPG และ PNG ขนาดไม่เกิน 5 MB
              </p>
              @if (editingCustomer()?.fileUrl) {
                <div class="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center">
                  <a
                    class="mt-2 inline-flex h-9 items-center justify-center gap-2 rounded-lg border border-sky-200 bg-white px-3 text-xs font-semibold text-sky-700 no-underline transition hover:bg-sky-50 hover:text-sky-900"
                    [href]="attachmentUrl(editingCustomer()!.fileUrl!)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <lucide-icon name="ExternalLink" [size]="15" aria-hidden="true" />
                    ดูไฟล์เดิม
                  </a>
                  <p class="m-0 text-xs font-normal text-slate-500">
                    หากเลือกไฟล์ใหม่จะแทนที่ไฟล์เดิม
                  </p>
                </div>
              }
            </div>
          </div>
        </div>

        <div
          class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 sm:flex-row sm:justify-end"
        >
          <button
            class="tw-button rounded-xl border border-slate-300 bg-white px-5 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100"
            type="button"
            (click)="closeCustomerModal()"
          >
            ยกเลิก
          </button>
          <button
            class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 py-2.5 font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] disabled:cursor-not-allowed disabled:opacity-50"
            type="submit"
            [disabled]="customerForm.invalid || isSaving()"
          >
            <lucide-icon name="Check" [size]="18" aria-hidden="true" />
            {{
              isSaving() ? 'กำลังบันทึก...' : editingCustomer() ? 'บันทึกการแก้ไข' : 'บันทึกลูกค้า'
            }}
          </button>
        </div>
      </form>
    </section>
  </div>
}

@if (selectedCustomer(); as customer) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeCustomerDetail()"
  >
    <section
      class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="customer-detail-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ customer.customerCode }}
          </p>
          <h2 id="customer-detail-title" class="m-0 text-xl font-bold text-slate-800">
            รายละเอียดลูกค้า
          </h2>
          <div class="mt-2"><app-status-badge [status]="customer.status" /></div>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeCustomerDetail()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>
      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลทั่วไป</h3>
        <dl
          class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
        >
          <div>
            <dt class="text-xs font-semibold text-slate-500">รหัสลูกค้า</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.customerCode }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">ประเภทลูกค้า</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">
              {{ customer.customerType === 'CORPORATE' ? 'บริษัท / นิติบุคคล' : 'บุคคลทั่วไป' }}
            </dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">ชื่อลูกค้า / บริษัท</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.name }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">
              เลขประจำตัวผู้เสียภาษี / บัตรประชาชน
            </dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.taxId || '-' }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">เบอร์โทรศัพท์</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.phone }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">อีเมล</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.email || '-' }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">LINE ID</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.lineId || '-' }}</dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">Sale ผู้ดูแล</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">
              {{ customer.salesOwner.firstName }} {{ customer.salesOwner.lastName }}
            </dd>
          </div>
          <div>
            <dt class="text-xs font-semibold text-slate-500">วันที่สร้าง</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">
              {{ customer.createdAt | date: 'dd MMM yyyy' }}
            </dd>
          </div>
          <div class="sm:col-span-2 lg:col-span-3">
            <dt class="text-xs font-semibold text-slate-500">ที่อยู่</dt>
            <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ customer.address || '-' }}</dd>
          </div>
          <div class="sm:col-span-2 lg:col-span-3">
            <dt class="text-xs font-semibold text-slate-500">ไฟล์แนบ</dt>
            <dd class="mt-1 mb-0 break-all font-semibold">
              @if (customer.fileUrl) {
                <a
                  class="inline-flex items-center gap-1.5 text-sky-700 hover:text-sky-900"
                  [href]="attachmentUrl(customer.fileUrl)"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="ดูเอกสารแนบในแท็บใหม่"
                >
                  ดูเอกสารแนบ
                  <lucide-icon name="ExternalLink" [size]="15" />
                </a>
              } @else {
                <span class="text-slate-800">-</span>
              }
            </dd>
          </div>
        </dl>
      </div>
      <div class="flex justify-end border-t border-slate-200 bg-slate-50 px-5 py-4 sm:px-6">
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100"
          (click)="closeCustomerDetail()"
        >
          ปิด
        </button>
      </div>
    </section>
  </div>
}
